import { render, staticRenderFns } from "./ReviewVisitDetails.vue?vue&type=template&id=40b0f9aa&scoped=true"
import script from "./ReviewVisitDetails.vue?vue&type=script&lang=js"
export * from "./ReviewVisitDetails.vue?vue&type=script&lang=js"
import style0 from "./ReviewVisitDetails.vue?vue&type=style&index=0&id=40b0f9aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b0f9aa",
  null
  
)

export default component.exports